import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import 'semantic-ui-css/components/transition.min.css';

import './Welcome.css';
import { WelcomeSplash, Button } from 'web-store-modules/packages/web-store-ui-library/'
import { getWelcomeExploreUrlAsync } from '../../../utils/StaticAssetManager.js';
import { getWelcomeMessageStyleAsync, getWelcomeTitleAsync, getStyleColorAsync } from '../../../utils/StoreConfigManager.js';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import WelcomeTooltip from './WelcomeTooltip';
import { isIpadSafari } from '../../../utils/DeviceDetector';

const defaultFontFamily = 'sans-serif';
const logo = 'https://cdn.obsess-vr.com/salesforce/northern_trail_logo.png';
const isMobile = isMobileDevice();
const isIpadAndSafari = isIpadSafari();
const welcomeShowTime = isMobile ? 1700000 : 1700000;

const welcomeMessageIpadSafariStyle = isIpadAndSafari ? { marginTop: '10em' } : {};
class Welcome extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onShowTooltip = this.onShowTooltip.bind(this)

        this.state = {
            text: '',
            imageSrc: '',
            visible: true,
            welcomeMessageStyle: null,
            pendingLoadAssetCount: 3,
            primaryColor: '',
            secondaryColor: '',
            visibleTooltip: false,
            showWelTooltip: true,
            showBroseTooltip: false,
            showProductTooltip: false,
            showBeautyTooltip: false,
            showOverlay: true,
            showMobileTooltip: false,
            isSplashVisible: true,
        };

        this.timeOutFunction = null;
        this.timeOutBrowseFunc = null;
        this.timeOutProductFunc = null;
        this.timeOutBeautyFunc = null;
    }

    componentDidMount() {
        getWelcomeMessageStyleAsync()
            .then(style => {
                if (style) {
                    const welcomeMessageStyle = {
                        fontFamily: style.name + ',' + defaultFontFamily
                    };
                    if (!isMobile) {
                        welcomeMessageStyle.fontSize = style.size;
                    }
                    this.setState(state => {
                        return {
                            welcomeMessageStyle: welcomeMessageStyle,
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
            })
            .catch(error => console.error(error));

        getStyleColorAsync()
            .then(style => {
                const primaryColor = style[0];
                const secondaryColor = style[1];
                this.setState({ primaryColor, secondaryColor })
            })
            .catch(error => console.error(error));

        getWelcomeTitleAsync()
            .then(welcomeText => {
                this.setState(state => {
                    const line1 = 'Welcome to the Salesforce Virtual Store';
                    const line2 = 'Powered by Obsess';
                    const line3 = 'Explore the Northern Trail Outfitters camping store';
                    const line4 = 'Buy your favorite outdoor gear as well as character NFTs';
                    const newWelcometext = 
                        <div className='welcome-message-wrapper'>
                            {/* <h4 className="welcomeTitle">{msg1}</h4> <br /> <p className="welcome-sub-title">{msg2}{msg3}</p> */}
                            <div className='welcomeTitle'>
                                <div>{line1}</div>
                                <div>{line2}</div>
                            </div>
                            <div className='welcome-sub-title'>
                                <p className="welcome-sub-title">{line3}<br />{line4}</p>
                            </div>
                        </div>
                    return {
                        text: newWelcometext,
                        pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                    };
                });
            })
            .catch(error => console.error(error));

        getWelcomeExploreUrlAsync()
            .then(url => {
                const welcomeImage = new Image();
                welcomeImage.onload = () => {
                    this.setState(state => {
                        return {
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
                welcomeImage.src = url;
                this.setState({ imageSrc: url })
            })
            .catch(error => console.error(error));

    }

    componentWillUnmount() {
        if (isMobile) {
            window.removeEventListener('touchend', this.hide);
        } else {
            window.removeEventListener('click', this.hide);
        }
        clearTimeout(this.timeOutProductFunc);
        clearTimeout(this.timeOutBeautyFunc);
        clearTimeout(this.timeOutBrowseFunc);
        if (this.timeOutFunction) {
            clearTimeout(this.timeOutFunction);
        }
    }

    hide() {
        this.setState({ visible: false });
    }

    onHide() {
        if(isMobile){
            this.props.setShowWelcomeModal(0)
            this.setState({
                isSplashVisible: false
            });
            this.onShowTooltip();
        }else{
            this.props.onWelcomeHide();
        }
            
        
    }

    getUpdatedWelcomeMessageStyle() {
        const { isFlatImageScene } = this.props;
        const { welcomeMessageStyle } = this.state;
        const updatedWelcomeMessageStyle = { ...welcomeMessageStyle, fontSize: '30px', fontFamily:'SangBleuKingdom-Medium', position: 'relative', top: '15px'}; 

        return isMobile ? welcomeMessageStyle  : updatedWelcomeMessageStyle;
    }

    onShowTooltip = () => {
        if (this.state.showWelTooltip) {
            this.timeOutBrowseFunc = setTimeout(
                () => this.setState({ showWelTooltip: false, showBroseTooltip: true, visibleTooltip: true,showOverlay:true }),
                100
            );

            this.timeOutProductFunc = setTimeout(() =>
                this.setState({ showProductTooltip: true }), 100);
            this.timeOutBeautyFunc = setTimeout(() =>
                this.setState({ showBeautyTooltip: true }), 100);

            setTimeout(() => {
                this.setState({ visibleTooltip: false, showOverlay: false});
                this.props.onWelcomeHide();
            }, welcomeShowTime);
        }
    }

    render() {
        const { showingUI, isFlatImageScene, flatImageButtonOption, flatImageButtonText } = this.props;
        const { text, visible, pendingLoadAssetCount, primaryColor, secondaryColor,welcomeFadeout, showBroseTooltip, showProductTooltip, showBeautyTooltip, visibleTooltip, showOverlay, showMobileTooltip, isSplashVisible } = this.state;
        
        if (!showingUI || pendingLoadAssetCount > 0) {
            return <React.Fragment />;
        }
        if (!this.timeOutFunction) {
            if (isMobile) {
                window.addEventListener('touchend', this.hide);
            } else {
                window.addEventListener('click', this.hide);
            }

            if(!isMobile){
                this.setState({ welcomeFadeout: 'welcome-fadeout' });
                this.onShowTooltip();
            }

            this.timeOutFunction = setTimeout(() => {
                this.hide();
            }, welcomeShowTime);
        }

        return (
            <div id={showOverlay ? 'welcome-overlay' : ''} className={welcomeFadeout}>
                {isSplashVisible && <div className="welcome-logo-section">
                    <img  src={logo} alt="welcome-logo" className='welcome-logo' />
                </div>}
                {isSplashVisible && <div className="welcome-message-section" style={welcomeMessageIpadSafariStyle}>
                    <Transition
                        visible={visible}
                        animation='fade'
                        duration={300}
                        onHide={this.onHide}
                    >
                        <WelcomeSplash
                            welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                            welcomeText={text}
                            hideTooltip={isMobile ? true : true}
                            isMobile={isMobile}
                        >
                            {
                                flatImageButtonOption &&
                                <>
                                    <Button
                                        style={{ ...this.getUpdatedWelcomeMessageStyle(), padding: '0.2em 1em', marginTop: '0.5em' }}
                                        primaryColor={primaryColor}
                                        secondaryColor={secondaryColor}
                                    >
                                        <p id='flat-image-button-text'>{flatImageButtonText}</p>
                                    </Button>
                                </>
                            }
                        </WelcomeSplash>
                    </Transition>
                </div>}
                {visibleTooltip  && 
                <Transition
                    visible={visibleTooltip}
                    animation='fade'
                    duration={500}
                >
                    <WelcomeTooltip 
                        welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                        showBroseTooltip={showBroseTooltip}
                        showBeautyTooltip={showBeautyTooltip}
                        showProductTooltip={showProductTooltip}
                        showMobileTooltip={showMobileTooltip}
                        isVisible={visibleTooltip}
                        onWelcomeHide={this.props.onWelcomeHide}
                        isMobile={isMobile} 
                    >
                    </WelcomeTooltip>
                </Transition>
            }
            </div>
        );
    }
}

Welcome.propTypes = {
    showingUI: PropTypes.bool,
    onWelcomeHide: PropTypes.func,
    isFlatImageScene: PropTypes.bool,
    flatImageButtonOption: PropTypes.bool,
    flatImageButtonText: PropTypes.string,
};

export default Welcome;
